import Local from '../classes/local';
import getUrlParameters from './getUrlParameters';

export default function setLanguage(language?: 'English' | 'Spanish') {
    if (language) {
        Local.setItem('language', language);
        return;
    }
    // check for language query param; anything other than es-mx default to English
    const urlParameters = getUrlParameters();
    if (urlParameters.has('Lang') || urlParameters.has('lang')) {
        const langParameter = (urlParameters.get('Lang') || urlParameters.get('lang'))!.toLowerCase();
        if (langParameter === 'es-mx') {
            Local.setItem('language', 'Spanish');
        } else {
            Local.setItem('language', 'English');
        }
        return;
    }
    if (!Local.getItem('language'))
        Local.setItem('language', 'English');
}
